"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterTextLocalized = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var DateFilterTitle_1 = require("../utils/Translations/DateFilterTitle");
var DateFilterTextLocalizedComponent = function (_a) {
    var dateFormat = _a.dateFormat, filter = _a.filter, intl = _a.intl;
    return react_1.default.createElement(react_1.default.Fragment, null, DateFilterTitle_1.getDateFilterTitle(filter, intl.locale, dateFormat));
};
exports.DateFilterTextLocalized = react_intl_1.injectIntl(DateFilterTextLocalizedComponent);
//# sourceMappingURL=DateFilterTextLocalized.js.map